import React from "react";
import { useNotification } from "../context/NotificationContext";
import { X } from "lucide-react";

// Notification component to display notifications
const Notification = () => {
  const { notifications, removeNotification } = useNotification();

  // Map notification types to color classes
  const getTypeStyles = (type) => {
    switch (type) {
      case "success":
        return "bg-green-100 border-green-500 text-green-800";
      case "error":
        return "bg-red-100 border-red-500 text-red-800";
      case "warning":
        return "bg-yellow-100 border-yellow-500 text-yellow-800";
      case "info":
      default:
        return "bg-blue-100 border-blue-500 text-blue-800";
    }
  };

  // Map notification types to icons
  const getTypeIcon = (type) => {
    switch (type) {
      case "success":
        return "✓";
      case "error":
        return "✕";
      case "warning":
        return "⚠";
      case "info":
      default:
        return "ℹ";
    }
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-5 right-5 z-50 flex flex-col gap-2 max-w-[400px]">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`flex items-start p-3 rounded-md border-l-4 shadow-md ${getTypeStyles(
            notification.type
          )}`}
          role="alert"
        >
          <div className="flex-shrink-0 mr-2">
            {getTypeIcon(notification.type)}
          </div>
          <div className="flex-grow pr-6">{notification.message}</div>
          <button
            onClick={() => removeNotification(notification.id)}
            className="flex-shrink-0 text-gray-500 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default Notification;
